// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2LXH0","content":"RecentSearches_content__1Mg_D"};